@if (!throbbingFlag) {
  <span>
    <button style="position:relative" type="submit" class="{{buttonClass}} position-rel" [disabled]="!enabled" (click)="submitForm(form)">
      <span>{{buttonText}}</span>
    </button>
  </span>
}

@if (throbbingFlag) {
  <span>
    <button type="submit" class="btn position-rel" class="{{buttonClass}}" [disabled]="enabled ? null : true" (click)="submitForm(form)">
      <span id="throbbingFlag"><i class="fas fa-spinner-third fa-spin throbbing-icon"></i> {{throbbingButtonText}}</span>
    </button>
  </span>
}
